import { useState, useCallback, useEffect } from 'react';

const useNodeData = (initialData) => {
  const [nodeData, setNodeData] = useState(initialData);

  const updateNodeData = useCallback((updater) => {
    setNodeData((prevData) => {
      const newData =
        typeof updater === 'function' ? updater(prevData) : updater;
      return { ...prevData, ...newData };
    });
  }, []);

  // Canvas setNodes patches deploy/output during the design harness walk.
  useEffect(() => {
    setNodeData((prev) => {
      const parameter_data = initialData?.parameter_data ?? prev.parameter_data;
      const deploy_status = initialData?.deploy_status ?? prev.deploy_status;
      const output_data = initialData?.output_data ?? prev.output_data;
      if (
        prev.parameter_data === parameter_data &&
        prev.deploy_status === deploy_status &&
        prev.output_data === output_data
      ) {
        return prev;
      }
      return { ...prev, parameter_data, deploy_status, output_data };
    });
  }, [
    initialData?.parameter_data,
    initialData?.deploy_status,
    initialData?.output_data,
  ]);

  return [nodeData, updateNodeData];
};

export default useNodeData;
